import { Occupancy } from "@ssc-booking/api-contracts"
import { t } from "@lingui/macro"
import { match, P } from "ts-pattern"

type GuestsMessageContent = {
    title: string
    content: string
}

export const guestsMessageContent = (guests: Occupancy): GuestsMessageContent | undefined => {
    return match(guests)
        .with({ adults: 1, kids: 0 }, () => ({
            title: t`Single Occupancy`,
            content: t`Please note single guests incur in at least a 25% solo supplement.`,
        }))
        .with({ adults: 1, kids: P.when((k) => k > 0) }, () => ({
            title: t`KIDS promotion`,
            content: t`To benefit from our child fares, children must be booked as 3rd, 4th, 5th or 6th passengers in suite. Guests 1st and 2nd are not eligible, regardless of age.`,
        }))
        .with({ adults: P.when((a) => a > 2) }, () => ({
            title: t`3rd & 4TH guest REDUCTION`,
            content: t`If 4 guests accommodate a one-bedroom suite, the 3rd & 4th guests are eligible for a price reduction.`,
        }))
        .with({ adults: 2, kids: P.when((k) => k > 0) }, () => ({
            title: t`KIDS promotion`,
            content: t`Safety restrictions and further promotions may apply based on the child’s age. Please inform our Reservations Team.`,
        }))
        .otherwise(() => undefined)
}
